import { ref, onUnmounted } from 'vue'
import { createSafeResizeObserver } from '@/helpers/SafeStorage'

export function useResizeObserver(callback: (entries: ResizeObserverEntry[]) => void) {
  const resizeObserver = ref<ResizeObserver | null>(null)
  const isObserving = ref(false)

  const observe = (element: Element) => {
    if (!element || isObserving.value) return

    try {
      resizeObserver.value = createSafeResizeObserver(callback)
      if (resizeObserver.value) {
        resizeObserver.value.observe(element)
        isObserving.value = true
      }
    } catch (error) {
      console.warn('Failed to observe element with ResizeObserver:', error)
    }
  }

  const unobserve = (element: Element) => {
    if (resizeObserver.value && isObserving.value) {
      try {
        resizeObserver.value.unobserve(element)
        isObserving.value = false
      } catch (error) {
        console.warn('Failed to unobserve element:', error)
      }
    }
  }

  const disconnect = () => {
    if (resizeObserver.value) {
      try {
        resizeObserver.value.disconnect()
        isObserving.value = false
      } catch (error) {
        console.warn('Failed to disconnect ResizeObserver:', error)
      }
    }
  }

  onUnmounted(() => {
    disconnect()
  })

  return {
    observe,
    unobserve,
    disconnect,
    isObserving,
  }
}
